import React, { useState, useEffect } from "react";

import Layout from "../../components/Layout/Layout";
import SEO from "../../components/SEO/SEO";
import AboutAmc from "./components/AboutAmc";
import Table from "./components/Table";
import TopAmc from "./components/TopAmc";
import HowToInvest from "./components/HowToInvest";
import TopFundManager from "./components/TopFundManager";
import RequiredDocuments from "./components/RequiredDocuments";
import BestSchemes from "./components/BestSchemes";
import FinancialRatio from "./components/FinancialRatio";
import AmcDetailCard from "./components/AmcDetailCard";
import OtherAmc from "./components/OtherAmc";

const AMCDetails = ({ pageContext: { allAmcs, amc, pageLink } }) => {
  const custom_order = [
    "top_10_funds",
    "top_selling",
    "top_equity",
    "top_hybrid",
    "top_debt"
  ];
  const [displayAmcDetailCard, setDisplayAmcDetailCard] = useState(true);
  useEffect(() => { }, []);
  return (
    <Layout>
      <SEO link={pageLink} />
      <div className="flex-row space-between wrapper">
        <div className="column1">
          <AboutAmc amc={amc.amc_profile} />
          {custom_order.map((key, id) => {
            return (
              <Table
                data={amc[key]}
                name={key}
                key={id}
                amcName={amc.amc_profile.display_name}
              />
            );
          })}
          {amc.best_scheme && <BestSchemes data={amc.best_scheme} />}
          {amc.how_to_invest && <HowToInvest data={amc.how_to_invest} />}
          {amc.documents_required && (
            <RequiredDocuments data={amc.documents_required} />
          )}
          {amc.top_fund_managers && (
            <TopFundManager data={amc.top_fund_managers} />
          )}
          {amc.financial_ratios && (
            <FinancialRatio data={amc.financial_ratios} />
          )}

        </div>
        <div className="column2">
          <AmcDetailCard amc={amc.amc_profile} where="SIDE_COLUMN" />
          <OtherAmc allAmcs={allAmcs} />
        </div>
      </div>
      <TopAmc topAmcData={amc} />
      <style jsx>{`
              .wrapper{
                margin:60px auto;
                max-width:1080px;
              }
              .column1 {
                width: 65%;
              }
              .column2 {
                width: 29%;
                margin-top: 16px;
              }
              @media only screen and (max-width: 768px) {
                .wrapper {
                  max-width: 77vw;
                  flex-direction: column;
                }
                .column1 {
                  width: 100%;
                }
                .column2 {
                  width: 100%;
                }
              }
              @media only screen and (max-width: 600px) {
                .wrapper {
                  width: 90vw;
                  margin-top: 40px;
                  max-width: none;
                }
              }
             
            `}</style>
    </Layout>
  );
};

export default AMCDetails;
